






























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import * as api from '@/api';
interface Form {
    orgList: string[];
}
/**
 * 添加组织
 *
 * @author wb_zhanghongwei
 * @date 07/19/2021
 */
@Component
export default class AddRgUserDialog extends Vue {
    @Prop({ default: false })
    visible: boolean;
    @Prop({ default: 0 })
    id: number;
    @Prop({ default: '' })
    userType: string;

    show: Boolean = false;
    formCustom: Form = {
        orgList: []
    };
    btnLoading: Boolean = false;
    searchLoading: Boolean = false;
    orgDetailList: any = [];
    @Watch('visible', { immediate: true })
    onShowChanged(val) {
        this.show = val;
        if (val) {
            this.formCustom.orgList = [];
            this.orgDetailList = [];
        }
    }
    close() {
        this.$emit('update:visible', false);
    }
    async submit() {
        if (this.btnLoading) {
            return;
        }
        this.btnLoading = true;
        try {
            const orgIds = this.formCustom.orgList.map((item: any) => {
                return item.orgId;
            });
            await api.rgApi.orgAdd({
                orgIds,
                role: this.userType,
                rgId: this.id
            });
            this.$mtd.message({
                message: '添加 RG 组织成功',
                type: 'success'
            });
            this.$emit('success');
            this.close();
        } catch (e) {
            console.log(e);
        }
        this.btnLoading = false;
    }
    formatter(val) {
        if (val.value) {
            return `${val.value.orgName}`;
        }
    }
    async searchOrg(query) {
        if (query.length < 1) {
            // this.orgDetailList = defaultOption;
            return;
        }
        this.searchLoading = true;
        try {
            const res = await api.ctiApi.orgDetailByPath(encodeURIComponent(query));
            const { data } = res;
            if (data) {
                this.orgDetailList = [data];
            } else {
                this.orgDetailList = [];
            }
        } catch (e) {
            console.log(e);
        }
        this.searchLoading = false;
    }
}
